import {
  DetailedHTMLProps,
  FC,
  InputHTMLAttributes,
  ReactNode,
  RefObject,
  useState,
} from 'react';
import {
  Input,
  InputErrorMessage,
  InputRightButton,
  InputBaseWrapper,
  MovingLabel,
} from './InputBase.styles';
import Icon from '../Icon/Icon';
import { useTheme } from 'styled-components';

interface OwnProps
  extends Pick<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    | 'value'
    | 'onChange'
    | 'placeholder'
    | 'type'
    | 'id'
    | 'autoFocus'
    | 'disabled'
  > {
  label: string;
  wrapperRef?:
    | ((instance: HTMLDivElement | null) => void)
    | RefObject<HTMLDivElement>
    | null;
  icon?: string;
  error?: string;
  renderInputComponent?: (params: {
    onFocus: () => void;
    onBlur: () => void;
    isFocused: boolean;
  }) => ReactNode;
  onRightButtonClick?: () => unknown;
}

const InputBase: FC<OwnProps> = ({
  value,
  onChange,
  placeholder,
  type,
  id,
  autoFocus,
  error,
  label,
  icon,
  wrapperRef,
  renderInputComponent,
  onRightButtonClick,
  disabled,
}) => {
  const theme = useTheme();
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <InputBaseWrapper
        focused={isFocused}
        error={!!error}
        ref={wrapperRef}
        disabled={disabled}
      >
        <MovingLabel moved={isFocused || !!value} disabled={disabled}>
          {label}
        </MovingLabel>
        {renderInputComponent ? (
          renderInputComponent({
            onFocus: () => setIsFocused(true),
            onBlur: () => setIsFocused(false),
            isFocused,
          })
        ) : (
          <Input
            value={value}
            id={id}
            type={type}
            placeholder={placeholder}
            autoFocus={autoFocus}
            autoComplete="off"
            onChange={onChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            disabled={disabled}
          />
        )}

        {!!icon && (
          <InputRightButton type="button" onClick={onRightButtonClick}>
            <Icon icon={icon} />
          </InputRightButton>
        )}
      </InputBaseWrapper>

      {error && (
        <InputErrorMessage mt mtValue={theme.spacing.xxs}>
          {error}
        </InputErrorMessage>
      )}
    </>
  );
};

export default InputBase;
